import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import CollectionsHero from "./components/CollectionsHero";
import CollectionsGrid from "./components/CollectionsGrid";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Collections() {
  useScrollToTop();
  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main className="pt-0">
        <CollectionsHero />
        <CollectionsGrid />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
